import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'account-settings-cookie-prefs',
		path: '/account_settings/manage_cookies',
		component: loadable(async () => import(/* webpackChunkName: "pages/accountSettings-cookiePrefs" */ './index'), {
			exportName: 'CookiePrefs',
			fallback: Loading,
		}),
		frame: true,
		preventCookieWall: true,
		ssr: {
			// caveat: since we're still using localStorage, part of the page will be client-rendered
			enabled: true,
			seo: false,
		},
	},
];
